import React, { useState } from 'react'
import { Outlet } from 'react-router-dom'
import Sidebar from './Sidebar'
import Header from './Header'

const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false)

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-[280px_1fr]" style={{ background: 'var(--color-bg)' }}>
      {/* Sidebar */}
      <Sidebar open={sidebarOpen} setOpen={setSidebarOpen} />

      {/* Main content */}
      <main className="min-w-0">
        {/* Header / Topbar */}
        <Header onMenuClick={() => setSidebarOpen(true)} />

        {/* Page content */}
        <div className="px-5 pb-8 lg:px-6">
          <Outlet />
        </div>
      </main>
    </div>
  )
}

export default Layout
